// extracted by mini-css-extract-plugin
export var carouselContentContainer = "CarouselSlideWithImage-module__carouselContentContainer--1v7vp";
export var carouselSlideContainer = "CarouselSlideWithImage-module__carouselSlideContainer--POUmj";
export var col = "CarouselSlideWithImage-module__col--qsTer";
export var colMd = "CarouselSlideWithImage-module__colMd--1sYkz";
export var icon = "CarouselSlideWithImage-module__icon--3lqPo";
export var iconWrapper = "CarouselSlideWithImage-module__iconWrapper--NVxFf";
export var imgWrapper = "CarouselSlideWithImage-module__imgWrapper--2wmey";
export var wrapper = "CarouselSlideWithImage-module__wrapper--2y6py";